import { cls } from "../../../NUI/utils";
import { Container } from "semantic-ui-react";

export const ReviewRating = ({ rating, totalReviews, clsn = [] }) => {
  const stars_empty = 5 - Math.ceil(rating);
  const perc = Math.round((rating - parseInt(rating)) * 100);

  return (
    <div className={cls( clsn)}>
      <svg className="w-0 h-0" viewBox="0 0 24 24">
        <defs>
          <mask id="perc">
            <rect x="0" y="0" className="h-full w-full fill-white" />
            <rect
              x={String(perc) + "%"}
              y="0"
              className="h-full w-full fill-[#3d3d3d]"
            />
          </mask>
          <symbol
            className="h-fit"
            xmlns="http://www.w3.org/2000/svg"
            id="star"
          >
            <path d="M12.5212 0.447798L15.8362 7.07613L22.2129 7.71446C22.552 7.74763 22.7789 7.92463 22.8937 8.24538C23.0085 8.56613 22.9455 8.84696 22.7045 9.0878L17.4495 14.3411L19.3979 21.4795C19.4889 21.8159 19.3997 22.0945 19.1302 22.3155C18.8607 22.5365 18.57 22.5695 18.2579 22.4145L11.7995 19.1845L5.3412 22.4178C5.02912 22.5736 4.73837 22.5409 4.46879 22.3195C4.19929 22.098 4.11062 21.8192 4.20287 21.4828L6.14954 14.3411L0.894537 9.08446C0.653621 8.84363 0.590538 8.5628 0.705371 8.24205C0.820204 7.9213 1.04712 7.7443 1.3862 7.71113L7.76287 7.0728L11.0779 0.444464C11.2271 0.147297 11.468 -0.000869237 11.8005 -0.000119237C12.133 0.000630763 12.3733 0.149964 12.5212 0.447798Z" />
          </symbol>
        </defs>
      </svg>

      <Container>
        {!totalReviews &&  <p className="font-normal text-center text-is2-body !mb-1">
          We’re rated on average {rating}/5
        </p>}
       
        <div className="flex flex-col items-center justify-center gap-1 pb-3 sm:pb-2">
          <div className="flex mt-2 gap-2">
            {Array(Math.floor(rating))
              .fill()
              .map((el, i) => (
                <svg key={i} className="h-6 w-6">
                  <use href="#star" className="fill-is2-yellow-500"></use>
                </svg>
              ))}
            {perc ? (
              <svg className="h-6 w-6">
                <use
                  href="#star"
                  mask="url(#perc)"
                  className="fill-is2-yellow-500"
                ></use>
              </svg>
            ) : null}
            {Array(stars_empty)
              .fill()
              .map((el, i) => (
                <svg key={i} className="h-6 w-6">
                  <use href="#star" className="fill-is2-yellow-500"></use>
                </svg>
              ))}
          </div>
        </div>
        {totalReviews &&  <p className="font-normal text-center text-is2-gray-150 !my-2 mx-12">
          We’re rated on average {rating}/5 from over {totalReviews} reviews  
        </p>}
      </Container>
    </div>
  );
};
